export const PLAN_LIMITS = {
  free:    { clouds: 1, deployments: 3,  servers: 1  },
  starter: { clouds: 3, deployments: 20, servers: 10 },
  pro:     { clouds: Infinity, deployments: Infinity, servers: Infinity },
};

export function getLimit(plan, resource) {
  return (PLAN_LIMITS[plan] || PLAN_LIMITS.free)[resource];
}

export function triggerPlanLimitModal(plan, resource, limit) {
  const labels = { clouds: 'cloud providers', deployments: 'deployments', servers: 'servers' };
  window.dispatchEvent(new CustomEvent('plan-limit-reached', {
    detail: {
      message: `Your ${plan} plan allows up to ${limit} ${labels[resource] || resource}. Upgrade to add more.`,
      plan, resourceType: resource, limit,
    },
  }));
}
